import { assign, createMachine } from "xstate";
import ConfirmedFailedPaymentDto from "../../PaymentContainerClient/dtos/ConfirmFailedPaymentResponseDto";
import ConfirmSuccessPaymentResponseDto from "../../PaymentContainerClient/dtos/ConfirmSuccessPaymentResponseDto";
import { confirmPayment } from "../usecases/confirmPayment";

interface Context {
    data?: ConfirmSuccessPaymentResponseDto | ConfirmedFailedPaymentDto;
    error?: any;
}

export enum PaymentConfirmedMachineState {
    Initial = "initial",
    Submitting = "submitting",
    Success = "success",
    Failure = "failure",
}

export const paymentConfirmedMachine = createMachine<Context>({
    id: "paymentConfirmedMachine",
    initial: PaymentConfirmedMachineState.Initial,
    states: {
        [PaymentConfirmedMachineState.Initial]: {
            on: {
                SUBMIT: PaymentConfirmedMachineState.Submitting,
            },
        },
        [PaymentConfirmedMachineState.Submitting]: {
            invoke: {
                src: (_context, event) =>
                    confirmPayment(event.token, event.jwtToken),
                onDone: {
                    target: PaymentConfirmedMachineState.Success,
                    actions: assign({
                        data: (_, event) => event.data,
                    }),
                },
                onError: {
                    target: PaymentConfirmedMachineState.Failure,
                    actions: [
                        assign({
                            error: (_, event) => event.data,
                        }),
                    ],
                },
            },
        },
        [PaymentConfirmedMachineState.Success]: {
            type: "final",
        },
        [PaymentConfirmedMachineState.Failure]: {
            type: "final",
        },
    },
});
